import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { ITVBetDTO, ITVBetGetToken } from '../../types/interfaces/LiveCasino/TVBetDTO';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { IGetGameUrl } from '../../types/slot';

import { formatJacktopLink, jacktopImages } from './JacktopUtils';
import { getCategories } from '../../utils/liveCasinoSort';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<ITVBetDTO[]>): ISlotViewItem[] =>
    data.map((item: ITVBetDTO) => ({
      id: String(item.code),
      gameId: String(item.code),
      gameName: item.name,
      description: item.name,
      provider: 'jacktop',
      routeProvider: 'jacktop',
      type: CasinoType.liveCasino,
      // imageUrl: `https://ganamos.co/images/jacktop/${item.img}`,
      imageUrl: jacktopImages[item.code] ?? item.img,
      tab: getCategories(item.name, item.code.toString(), 'jacktop'),
    }));

  convertGameUrl = ({ data, lang, gameId }: IGetGameUrl<ITVBetGetToken, unknown>) =>
    formatJacktopLink(data.token, gameId, lang);
}
export default Converter;
